export default "__VITE_ASSET__O6qMb66$__"